import { useMemo } from "react";
import { Box } from "@mui/material";

import ChartBlock, {
  chartHasSeriesData,
  pricingLineChartOptions,
} from "../../../routes/pricing-reports/ChartBlock";
import { cadCurrencyFormat } from "../../../routes/pricing-reports/constants";
import { buildLabelOriginPriceBarChart } from "./locationLabelChartUtils";

const labelOriginPriceBarChartOptions = {
  ...pricingLineChartOptions,
  plugins: {
    ...pricingLineChartOptions.plugins,
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (context) => {
          const value = typeof context.parsed?.y === "number" ? context.parsed.y : null;
          const count = context.dataset?.counts?.[context.dataIndex] || 0;
          const priceLabel = value != null ? cadCurrencyFormat.format(value) : "—";
          const countLabel = `${count} observation${count === 1 ? "" : "s"}`;
          return `${context.dataset.label}: ${priceLabel} (${countLabel})`;
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: { display: true, text: "Avg unit price (CAD / kg)" },
    },
  },
};

function LocationLabelOriginPriceChart({ productName, rows = [], isLoading = false, error = "" }) {
  const chart = useMemo(() => buildLabelOriginPriceBarChart(rows), [rows]);
  const titleName = productName || "selected product";

  return (
    <Box sx={{ mb: 2, backgroundColor: "#fff", border: "1px solid #eaeaea" }}>
      <ChartBlock
        title="Average price by country of origin"
        subtitle={`Linked price history for ${titleName}. Country is the labelled origin of the beef, not store province.`}
        chartType="bar"
        chart={chart}
        chartOptions={labelOriginPriceBarChartOptions}
        hasData={chartHasSeriesData(chart)}
        isLoading={isLoading}
        error={error}
        emptyMessage="No linked prices for this product with the current filters."
      />
    </Box>
  );
}

export default LocationLabelOriginPriceChart;
